
        <button
            type="button"
            (click)="toggleTheme()"
            class="relative grid h-9 w-9 place-items-center rounded-md bg-transparent text-[color:var(--foreground)] transition-colors hover:text-[color:var(--primary)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--ring)]/40 active:scale-95"
            [attr.aria-label]="isLight() ? 'Switch to dark theme' : 'Switch to light theme'"
        >
            <lucide-icon
                name="sun"
                class="col-start-1 row-start-1 h-5 w-5 text-[color:var(--primary)] transition-[opacity,transform] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] will-change-transform"
                [class.opacity-0]="!isLight()"
                [class.-rotate-90]="!isLight()"
                [class.scale-0]="!isLight()"
            ></lucide-icon>
            <lucide-icon
                name="moon"
                class="col-start-1 row-start-1 h-5 w-5 text-[color:var(--primary)] transition-[opacity,transform] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] will-change-transform"
                [class.opacity-0]="isLight()"
                [class.rotate-90]="isLight()"
                [class.scale-0]="isLight()"
            ></lucide-icon>
        </button>
    
